import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from './icons/AddIcon';
import ArrowDownIcon from './icons/ArrowDownIcon';
import ArrowIcon from './icons/ArrowIcon';
import ArrowUpIcon from './icons/ArrowUpIcon';
import CalendarIcon from './icons/CalendarIcon';
import ChatIcon from './icons/ChatIcon';
import CloseIcon from './icons/CloseIcon';
import DeleteIcon from './icons/DeleteIcon';
import DownloadIcon from './icons/DownloadIcon';
import DuplicateIcon from './icons/DuplicateIcon';
import EditIcon from './icons/EditIcon';
import EyeIcon from './icons/EyeIcon';
import InfoIcon from './icons/InfoIcon';
import LinkIcon from './icons/LinkIcon';
import LockIcon from './icons/LockIcon';
import LogoutIcon from './icons/LogoutIcon';
import MagnifierIcon from './icons/MagnifierIcon';
import MinusIcon from './icons/MinusIcon';
import NotificationIcon from './icons/NotificationIcon';
import ObjectIcon from './icons/ObjectIcon';
import OrderIcon from './icons/OrderIcon';
import PlusIcon from './icons/PlusIcon';
import PrintIcon from './icons/PrintIcon';
import ProffesionIcon from './icons/ProffesionIcon';
import ReportIcon from './icons/ReportIcon';
import SaveIcon from './icons/SaveIcon';
import SendIcon from './icons/SendIcon';
import SettingsIcon from './icons/SettingsIcon';
import SkillIcon from './icons/SkillIcon';
import StarIcon from './icons/StarIcon';
import UserCircleIcon from './icons/UserCircleIcon';
import UserIcon from './icons/UserIcon';
import WorkersIcon from './icons/WorkersIcon';
import CheckboxIcon from './icons/CheckboxIcon';
import MessageIcon from './icons/MessageIcon';

const renderSwitch = ({ name, ...props }) => {
    switch (name) {
        case 'add':
            return <AddIcon {...props} />;
        case 'arrow-down':
            return <ArrowDownIcon {...props} />;
        case 'arrow':
            return <ArrowIcon {...props} />;
        case 'arrow-up':
            return <ArrowUpIcon {...props} />;
        case 'calendar':
            return <CalendarIcon {...props} />;
        case 'chat':
            return <ChatIcon {...props} />;
        case 'close':
            return <CloseIcon {...props} />;
        case 'delete':
            return <DeleteIcon {...props} />;
        case 'download':
            return <DownloadIcon {...props} />;
        case 'duplicate':
            return <DuplicateIcon {...props} />;
        case 'edit':
            return <EditIcon {...props} />;
        case 'eye':
            return <EyeIcon {...props} />;
        case 'info':
            return <InfoIcon {...props} />;
        case 'link':
            return <LinkIcon {...props} />;
        case 'lock':
            return <LockIcon {...props} />;
        case 'logout':
            return <LogoutIcon {...props} />;
        case 'magnifier':
            return <MagnifierIcon {...props} />;
        case 'minus':
            return <MinusIcon {...props} />;
        case 'notification':
            return <NotificationIcon {...props} />;
        case 'object':
            return <ObjectIcon {...props} />;
        case 'order':
            return <OrderIcon {...props} />;
        case 'plus':
            return <PlusIcon {...props} />;
        case 'print':
            return <PrintIcon {...props} />;
        case 'proffesion':
            return <ProffesionIcon {...props} />;
        case 'report':
            return <ReportIcon {...props} />;
        case 'save':
            return <SaveIcon {...props} />;
        case 'send':
            return <SendIcon {...props} />;
        case 'settings':
            return <SettingsIcon {...props} />;
        case 'skill':
            return <SkillIcon {...props} />;
        case 'star':
            return <StarIcon {...props} />;
        case 'user-circle':
            return <UserCircleIcon {...props} />;
        case 'user':
            return <UserIcon {...props} />;
        case 'workers':
            return <WorkersIcon {...props} />;
        case 'checkbox':
            return <CheckboxIcon {...props} />;
        case 'message':
            return <MessageIcon {...props} />;
        default:
            return <AddIcon {...props} />;
    }
}

const Icon = ({ name, width, height, fill, stroke }) => (
    renderSwitch({ name, width, height, fill, stroke })
);

Icon.propTypes = {
    name: PropTypes.string
};

Icon.defaultProps = {
    name: ''
};

export default React.memo(Icon);
